import { EcommerceProductSectionModel } from '@/helpers/entities/models/EcommerceProductSectionModel';
import { omit } from 'lodash';
import { EcommerceProductDetailModel } from '@/helpers/entities/models/EcommerceProductDetailModel';
// import { EcommerceProductAddOnModel } from '@/helpers/entities/models/EcommerceProductAddOnModel';
import { EcommerceProductVariantModel } from '@/helpers/entities/models/EcommerceProductVariantModel';
import { EcommerceProductPromoModel } from '@/helpers/entities/models/EcommerceProductPromoModel';
import { PhotoModel } from '@/helpers/entities/models/PhotoModel';
import { EcommerceProductCategoryModel } from '@/helpers/entities/models/EcommerceProductCategoryModel';
import { EcommerceProductRegionAvailabilityModel } from './EcommerceProductRegionAvailabilityModel';
export class EcommerceProductFullModel {
    constructor(product) {
        const params = omit(product, [
            'productSections',
            'activePromo',
            'productRegionAvailabilities',
        ]);
        Object.assign(this, params);
        const node = (section) => {
            return new EcommerceProductSectionModel(section.node);
        };
        const hidden = (po) => {
            return !po.hidden && !!po.uuid;
        };
        this.sections = product.productSections.edges.map(node).filter(hidden);
        const detailNode = (detail) => {
            return new EcommerceProductDetailModel(detail.node);
        };
        this.details = product.productDetails.edges.map(detailNode);
        if (product.productRegionAvailabilities) {
            const regionNode = (region) => {
                return new EcommerceProductRegionAvailabilityModel(region.node);
            };
            this.productRegionAvailabilities = product.productRegionAvailabilities.edges.map(regionNode);
        }
        if (product.activePromo) {
            this.activePromo = new EcommerceProductPromoModel(product.activePromo);
        }
        const photoNode = (photo) => new PhotoModel(photo.node);
        this.photos = product.galleryPhotos.edges.map(photoNode);
        const categoryNode = (category) => new EcommerceProductCategoryModel(category.node);
        this.productCategories = product.productCategories.edges.map(categoryNode);
        // const addOnNode = (detail: ProductAddOnNode) => {
        //   return new EcommerceProductAddOnModel(detail.node);
        // };
        // this.productAddOns = product.productAddOns.edges.map(addOnNode);
        const variantNode = (detail) => {
            return new EcommerceProductVariantModel(detail.node);
        };
        this.productVariance = product.productVariance.edges.map(variantNode);
    }
}
